









import {Component, Prop, Vue} from 'vue-property-decorator'
import InputToggleItem from './InputToggleItem.vue'
import {IOption} from './models'

@Component({
  components: {
    InputToggleItem
  }
})
export default class InputToggle extends Vue {

  @Prop() value!: any
  @Prop({
    validator(value: any): boolean {
      return !!value?.length
    }
  }) readonly options!: IOption<any>[]

  private toggle(value: string): void {
    this.$emit('input', value);
  }

}
